 
  export class Permission {
     
       
        public id : number ;
        public windowTitle : string;
        public flgEmployeeType : boolean;
        public flg_add  :boolean;
        public flg_edit :boolean;
        public flg_delete :boolean;
        public flg_view :boolean;
        public flg_calculate  :boolean;  
        public flg_export :boolean;
        public employeeType  :number[] ;
        public employee_type_id :number;
       
}


// WEBPACK FOOTER //
// ./src/app/core/model/permission.ts